import { Card, CardBody } from '@nextui-org/card'
import Image from 'next/image'

import { MetadataLink } from '@/utils/fetchMetadata'
import bgImage from '@/assets/imgs/no-bg.jpg'
import { cn } from '@/utils/cn'

export const RenderMetaFromLink = ({
  metadata,
  onRemove,
}: {
  metadata: MetadataLink | null
  onRemove?: () => void
}) => {
  if (!metadata) return null

  return (
    <Card className="border border-white/10 bg-ss-dark">
      <div
        className={cn(
          'relative z-0  w-full overflow-hidden rounded-tl-[12px] rounded-tr-[12px]',
          metadata.images?.[0] ? 'aspect-[16/9]' : ' h-16',
        )}
      >
        {metadata.images?.[0] ? (
          <Image
            className="z-0 object-cover"
            src={metadata.images?.[0] || ''}
            fill
            sizes=""
            alt="Avatar"
            onError={(e) => (e.currentTarget.src = bgImage.src)}
          />
        ) : (
          <Image
            className="z-0 object-contain mt-2"
            src={metadata.favicons?.[0] || ''}
            fill
            sizes=""
            alt="Avatar"
            onError={(e) => (e.currentTarget.src = bgImage.src)}
          />
        )}

        {onRemove && (
          <button
            className="absolute right-2 top-2 z-[1] flex h-[24px] w-[24px] items-center justify-center rounded-full bg-white"
            onClick={onRemove}
          >
            <svg width="12" height="12" viewBox="0 0 6 6" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M5 1L1 5" stroke="#11142D" strokeLinecap="round" strokeLinejoin="round" />
              <path d="M5 5L1 1" stroke="#11142D" strokeLinecap="round" strokeLinejoin="round" />
            </svg>
          </button>
        )}
      </div>
      <CardBody>
        <p className="mb-1 text-base font-medium text-white">{metadata.title}</p>
        <span className="text-sm text-ss-grayscale-400">{metadata.description}</span>
      </CardBody>
    </Card>
  )
}
